import { GET_ALL_SUBSCRIPTION, GET_ALL_SUBSCRIPTION_FAILED, GET_ALL_SUBSCRIPTION_SUCCESS } from "../../constants/subscriptionListConstants"

const initialState = {
    isLoading: false,
    error: null
}

const SubscriptionReducer = (state = initialState, action) => {
    switch(action.type) {
        case GET_ALL_SUBSCRIPTION:
            return {
                ...state,
                isLoading: true,
            }
         case GET_ALL_SUBSCRIPTION_SUCCESS:
            return {
                ...action.payload,
                 isLoading: false,
                 error: null
            }
        case GET_ALL_SUBSCRIPTION_FAILED:
            return {
                 isLoading: false,
                 error: action.payload
            }
        default:
            return state;
    }
}

export default SubscriptionReducer;